import React from 'react'

const Orders = () => {
  // Git Hub Url Updated
  return (
    <div className='container-xxl'>
        <div className="row">
            <div className="col-12">
                
            </div>
        </div>
    </div>
  )
}

export default Orders